import { initContext } from '@/base/context-init'
import App from './App.vue'
import Vue from 'vue'

initContext('gkpge', App)
Vue.prototype.$VUE_PAYWALL_FORCE_SINGLE_PAYMENT = true
Vue.prototype.$VUE_USE_APP_BLUEMEDIA = true
